<template>
  <pg-button
      :href="hubLinksLink(hubLinksObj)"
      :targetBlank="hubLinksObj.onBlank"
      :linkNofollow="hubLinksObj.noFollow"
      :key="hubLinksObj.uuid"
      :eventName="eventName(hubLinksObj)"
      :eventParams="hubLinksParams(hubLinksObj)"
      :analyticsData="analyticsData"
  >
    <div class="hub-links__icon-container">
      <i v-if="getIcon" :class="`hub-links__icon icon-${getIcon}`" aria-hidden="true"></i>
      <span class="hub-links__text">{{ getLabel }}</span>
    </div>
  </pg-button>
</template>

<script>
import PgButton from "../Button/Button.vue";

export default {

  name: "AdvancedButtonWrapper",
  components: {
    PgButton,
  },
  props: {
    hubLinksObj: {
      type: Object,
      default: () => {
      }
    },
    analyticsData: {
      type: Object,
      default: () => {
      }
    }
  },
  computed: {
    eventName() {
      return hubLinksObj => {
        if (hubLinksObj.behaviour == 'link' || hubLinksObj.behaviour === undefined) return;
        return `MarketingTool:${hubLinksObj.behaviour}`;
      }
    },
    hubLinksLink() {
      return hubLinksObj => {
        if (hubLinksObj.document) {
          return this.$options.filters.mgnlMedia(hubLinksObj.document, "url");
        } else {
          return this.$options.filters.mgnlLink(hubLinksObj.link, "url");
        }
      }
    },
    hubLinksParams() {
      return hubLinksObj => {
        const params = {...hubLinksObj};
        // cleaning properties not needed
        delete params.link;
        delete params.document;
        delete params.listStyle;
        delete params.onBlank;
        delete params.noFollow;
        delete params.label;
        delete params.uuid;

        return params;
      }
    },
    getIcon() {
      return this.hubLinksObj.icon || this.hubLinksObj.marketingToolIcon
    },

    getLabel() {
      if(this.hubLinksObj.label) return this.hubLinksObj.label
      if(this.hubLinksObj.marketingToolLabel) return this.hubLinksObj.marketingToolLabel
      return ""
    },
    target() {
      return this.hubLinksObj.onBlank ? '_blank' : undefined;
    },
    noFollow() {
      return this.hubLinksObj.noFollow ? 'nofollow' : undefined;
    }
  }
};
</script>